import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function SiteHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

    const [hidden, setHidden] = useState(false);





  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { label: "Home", href: "/" },
    { label: "Stay", href: "/stay" },
    { label: "Gallery", href: "/gallery" },
    { label: "Our Story", href: "/our-story" },
  ];

  const socialLinks = [
    {
      label: "Facebook",
      href: "https://www.facebook.com/profile.php?id=61583556767193",
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M22 12.06c0-5.52-4.48-10-10-10s-10 4.48-10 10c0 4.99 3.66 9.12 8.44 9.88v-6.99H8.13v-2.89h2.31V9.41c0-2.28 1.36-3.54 3.44-3.54.99 0 2.03.18 2.03.18v2.24h-1.14c-1.13 0-1.49.7-1.49 1.41v1.7h2.54l-.41 2.89h-2.13v6.99C18.34 21.18 22 17.05 22 12.06Z" />
        </svg>
      ),
    },
    {
      label: "Instagram",
      href: "https://www.instagram.com/gawkari_hillside/",
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <rect x="3" y="3" width="18" height="18" rx="4.5" />
          <circle cx="12" cy="12" r="3.8" />
          <circle cx="17.3" cy="6.7" r="0.9" fill="currentColor" stroke="none" />
        </svg>
      ),
    },
    {
      label: "X",
      href: "https://x.com/gawkari_hilside",
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.9 5.1h-2.3l-3.33 4.18-3.1-4.18H5.1l5.16 6.9-4.96 6.9h2.3l3.75-4.8 3.54 4.8h5.02l-5.3-7.14 5.29-6.66Z" />
        </svg>
      ),
    },
    {
      label: "YouTube",
      href: "https://www.youtube.com/@Gawkari",
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21.5 8.3a2.5 2.5 0 0 0-1.76-1.77C18.17 6 12 6 12 6s-6.17 0-7.74.53A2.5 2.5 0 0 0 2.5 8.3 26.4 26.4 0 0 0 2 12c-.01 1.24.04 2.48.5 3.7a2.5 2.5 0 0 0 1.76 1.77C5.83 18 12 18 12 18s6.17 0 7.74-.53a2.5 2.5 0 0 0 1.76-1.77c.46-1.22.51-2.46.5-3.7.01-1.24-.04-2.48-.5-3.7ZM10.4 14.6V9.4l4.53 2.6-4.53 2.6Z" />
        </svg>
      ),
    },
  ];

  return (
    <>
      <nav
        className={`navbar navbar-expand-lg p-0 ${
          isScrolled ? "site-navbar--scrolled" : "site-navbar--top"
        }`}
      >
        <div className={`container bg-white px-4 py-1 shadow-sm ${mobileMenuOpen ? 'rounded-3' : 'rounded-pill'}`}>
          {/* Brand/Logo */}
          <Link to="/" className="navbar-brand py-0">
            <img
              src="https://res.cloudinary.com/dmxiklmuc/image/upload/v1761388477/Gawkari_HillSide_t3pzmm.png"
              alt="Gawkari Hillside"
              height="55"
              style={{ maxWidth: '180px', objectFit: 'contain' }}
            />
          </Link>

          {/* Mobile Toggle Button */}
          <button
            className="navbar-toggler border-0 shadow-none"
            type="button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-controls="navbarNav"
            aria-expanded={mobileMenuOpen}
            aria-label="Toggle navigation"
            style={{ outline: 'none', boxShadow: 'none' }}
          >
            {mobileMenuOpen ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M3 12h18M3 6h18M3 18h18" />
              </svg>
            )}
          </button>

          {/* Nav Links */}
          <div className={`navbar-collapse ${mobileMenuOpen ? 'show' : 'collapse'}`} id="navbarNav">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0 align-items-lg-center gap-lg-1">
              {navLinks.map((link) => (
                <li key={link.href} className="nav-item">
                  <Link
                    to={link.href}
                    className={`nav-link px-3 py-2 fs-4 ${location.pathname === link.href ? 'active fw-bold' : ''}`}
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            
            {/* Book Now Button */}
            <div className="d-flex mt-2 mt-lg-0">
              <Link
                to="/enquiry"
                className="btn btn-primary rounded-pill px-4"
                onClick={() => setMobileMenuOpen(false)}
              >
                Book Now
              </Link>
            </div>

            {/* Mobile Social Links */}
            <div className="d-lg-none border-top mt-3 pt-3">
              <div className="d-flex justify-content-center gap-3">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    className="text-muted"
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
